// js/core/Boat.js
// 黎先生（行人）實體：位置、速度、朝向、體力、已收集物、實際足跡。

export class Boat {
  constructor(start, attrs) {
    this.x = start.x;
    this.y = start.y;
    this.vx = 0;
    this.vy = 0;
    this.heading = -Math.PI / 2; // 朝上
    this.attrs = attrs;           // { speed, durability, turn_resistance, wind_affinity }
    this.maxDurability = attrs.durability;
    this.durability = attrs.durability;

    this.wp = 0;                  // 下一個目標路點索引
    this.stopIdx = 0;             // 多站關卡：下一個要到訪的站（順序）
    this.boostT = 0;              // 咖啡因衝刺剩餘秒數
    this.delivered = false;
    this.failed = false;
    this.collisions = 0;
    this.collected = [];

    this.trail = [{ x: this.x, y: this.y }];
    this._trailT = 0;
  }

  get speed() {
    return Math.hypot(this.vx, this.vy);
  }
}
